module.exports = __webpack_public_path__ + "static/media/logo_text_cn@2x.c2ce740c.png";